<template>
  <header :class="{ 'header-with-toolbar': $auth.check(2) }">
    <div class="admin-toolbar" v-if="$auth.check(2)">
      <ul>
        <li class="nav-item">
          <strong><a href="/nova" target="_blank" class="nav-link">{{'w.header.nova-admin'|t}}</a></strong>
        </li>
        <li class="nav-item">
            <a href="/logout" class="nav-link" @click.prevent="logout()">{{'w.header.logout'|t}}</a>
        </li>
        <li v-if="! $store.settings.app_env">
          <p class="" style="color: red; margin: 0;"><b>App not in production</b></p>
        </li>
      </ul>
    </div>
    <div class="container-full">
        <div class="header-container ml-2 mr-2 mt-2 mt-md-3 mb-md-3 ml-md-3 mr-md-3">
            <nav class="navbar navbar-light navbar-expand-lg d-flex justify-content-between align-items-center p-0">
            <router-link class="navbar-brand" to="/" active-class="active" exact>
                <img id="logo-sonotron" src="/storage/img/logo/logo-sonotron.svg" alt="Sonotron logo" />
                <img id="logo-sonotron-fixed" src="/storage/img/logo/logo-sonotron-fixed.svg" alt="Logo fixed" />
            </router-link>

            <div class="header-right d-flex align-items-center">

              <ul class="language-switcher">
                <li>
                  <a href="#" :class="{ active: (locale == 'en') }" @click.prevent="changeLocale('en')">EN</a>
                </li>
                <li>
                  <a href="#" :class="{ active: (locale == 'fr') }" @click.prevent="changeLocale('fr')">FR</a>
                </li>
              </ul>
                <router-link class="btn" to="/book" active-class="active"><span>{{'w.header.book-a-room'|t}}</span></router-link>

                <ul class="icon-nav d-flex align-items-center nav-list">

                <b-nav-item-dropdown v-show="$auth.check()" extra-toggle-classes="nav-link-custom" ref="cartDropdown" class="dropdown-cart" :class="{ 'cart-has-been-added': $store.cart.content }" @show="showCartDropdown()" @hide="hideCartDropdown()" right>
                  <template slot="button-content">
                    <simple-svg :filepath="'/storage/img/icon/icon-bag.svg'" />
                    <div class="badge-wrapper">
                      <b-badge v-if="$store.cart.content" pill variant="success">
                      <span>{{$store.cart.content.length}}</span>
                      </b-badge>
                    </div>
                  </template>

                  <template v-if="$store.cart.content && $store.cart.content.length && $store.rooms.content">
                    <b-list-group class="cart-list" :class="{ 'more-than-1-items': $store.cart.content.length > 1 }">
                      <template v-for="(cartitem,index) in $store.cart.content">

                        <!--
                          Rooms
                        -->

                        <b-list-group-item class="cart-item d-flex" v-if="cartitem.room_id && $store.rooms.content[cartitem.room_id-1]">
                          <div class="img-wrapper">
                            <div class="room-image" :style="'background-image:url('+$store.rooms.content[cartitem.room_id-1].images[0]+')'"></div>
                          </div>
                          <div class="text-wrapper d-flex justify-content-between">
                            <div class="left-infos">
                              <h5>{{'w.header.title-room'|t}}</h5>
                              <div class="room-name">{{'w.header.title-room'|t}} n°{{ cartitem.room_id }}</div>
                              <div class="booking-date">{{cartitem.date|formatDate}}</div>
                              <div class="booking-hours">{{'w.header.from'|t}} {{cartitem.from}}:00 {{'w.header.to'|t}} {{cartitem.to}}:00</div>
                            </div>
                            <div class="right-infos">
                              <template v-if="cartitem.price_reduced">
                              <div class="booking-price"><del>{{cartitem.price}}€</del> {{cartitem.price_reduced}}€</div>
                              </template>
                              <template v-else>
                              <div class="booking-price">{{cartitem.price}}€</div>
                              </template>
                            </div>
                          </div>
                        </b-list-group-item>


                        <!--
                          Events
                        -->
                        <b-list-group-item class="cart-item d-flex" v-else>
                          <div class="img-wrapper">
                            <div class="room-image" :style="`background-image:url('storage/${cartitem.event.cover}')`"></div>
                          </div>
                          <div class="text-wrapper d-flex justify-content-between">
                            <div class="left-infos">
                              <h5>{{ $i18n.locale == 'fr' ? cartitem.event.category.name : cartitem.event.category.name_en }}</h5>
                              <div class="room-name">{{ $i18n.locale == 'fr' ? cartitem.event.name : cartitem.event.name_en }} (x{{ cartitem.tickets }})</div>
                              <div class="booking-date">{{cartitem.date|formatDate}}</div>
                              <div class="booking-hours">{{'w.header.from'|t}} {{cartitem.event.from | formatTimeEvent}} {{'w.header.to'|t}} {{cartitem.event.to | formatTimeEvent}}</div>
                            </div>
                            <div class="right-infos" v-if="cartitem.price">
                              <template v-if="cartitem.price_reduced">
                                <div class="booking-price"><del>{{cartitem.price}}€</del> {{cartitem.price_reduced}}€</div>
                              </template>
                              <template v-else>
                                <div class="booking-price">{{cartitem.price}}€</div>
                              </template>
                            </div>
                            <div class="right-infos" v-else>
                              <div class="booking-price">{{'w.header.event-free'|t}}</div>
                            </div>
                          </div>
                        </b-list-group-item>
                      </template>
                    </b-list-group>
                    <p class="cart-total">Total : <span class="cart-total-price">{{$store.cart.total.toLocaleString()}}€</span></p>
                  </template>
                  <template v-else>
                    <p>{{'w.header.cart-empty'|t}}</p>
                  </template>
                  <router-link class="btn" to="/cart" active-class="active" exact><span>{{'w.header.go-to-cart'|t}}</span></router-link>
                  <div class="btn-wrapper d-flex justify-content-center">
                    <router-link class="btn-link" to="/book" active-class="active" exact>{{'w.header.book-another'|t}}</router-link>
                  </div>
                </b-nav-item-dropdown>

                    <li v-if="!$auth.check()" class="profile"><router-link class="nav-link" to="/login" active-class="active" name="User account" exact><simple-svg :filepath="'/storage/img/icon/icon-profile.svg'" /></router-link></li>

                    <b-nav-item-dropdown v-if="$auth.check()" extra-toggle-classes="nav-link-custom" ref="profileDropdown" class="dropdown-profile" @show="showProfileDropdown()" @hide="hideProfileDropdown()" right>
                      <template slot="button-content">
                        <div class="badge-wrapper">
                         <b-badge v-if="$store.user && $store.user.name" pill variant="success"><span>{{$store.user.name.charAt(0)}}</span></b-badge>
                        </div>
                      </template>
                      <ul>
                        <li class="nav-item" v-if="$auth.check()">
                            <router-link class="nav-link" to="/dashboard" name="Dashboard" active-class="active">{{'w.header.my-bookings'|t}}</router-link>
                        </li>
                        <li class="nav-item" v-if="$auth.check()">
                            <router-link class="nav-link" to="/profile" name="Profile" active-class="active">{{'w.header.my-profile'|t}}</router-link>
                        </li>
                        <li class="nav-item" v-if="$auth.check()">
                            <router-link class="nav-link" to="/giftcards" name="Giftcards" active-class="active">{{'w.header.gift-cards'|t}}</router-link>
                        </li>
                        <li class="nav-item" v-if="$auth.check()">
                            <a href="/logout" name="Logout" class="nav-link" @click.prevent="logout()">{{'w.header.logout'|t}}</a>
                        </li>
                      </ul>
                    </b-nav-item-dropdown>

                    <li class="d-flex align-items-center"><button class="burger-button" type="button" @click="toggleMenu()"><span></span><span></span><span></span><div class="close-btn">{{'w.header.close'|t}}</div></button></li>
                </ul>
            </div>

            <div class="big-menu">
              <div class="container">
                <ul class="main-nav animate-outToLeft">
                  <li class="nav-item">
                    <router-link class="nav-link" to="/discover" active-class="active" exact>{{'w.header.discover'|t}}</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link class="nav-link" to="/book" active-class="active">{{'w.header.reserve'|t}}</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link class="nav-link" to="/blog" active-class="active">{{'w.header.blog'|t}}</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link class="nav-link" to="/events" active-class="active">{{'w.header.agenda'|t}}</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link class="nav-link" to="/faq" active-class="active">{{'faq'|t}}</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link class="nav-link" to="/contact" active-class="active">{{'w.header.contact'|t}}</router-link>
                  </li>
                </ul>

                <div class="menu-image">
                  <div class="image-text" v-html="$t('w.header.baseline')"></div>
                </div>

              </div>
            </div>
          </nav>
        </div>
    </div>
  </header>
</template>


<script>
    export default {
      data() {
        return {
        }
      },

      methods: {
        toggleMenu() {
          $("body").toggleClass('menu-open');
          $("html").toggleClass('html-menu-open');

          (function($) {
              $.fn.hasScrollBar = function() {
                  return this.get(0).scrollHeight > this.height();
              }
          })(jQuery);
        },
        showProfileDropdown() {
          $("body").addClass('dropdown-open')
        },
        hideProfileDropdown() {
          $("body").removeClass('dropdown-open')
        },
        showCartDropdown() {
          if(this.$store.cart.cartScrollBar) this.$store.cart.cartScrollBar.update()
          $("body").addClass('dropdown-open')

        },
        hideCartDropdown() {
          $("body").removeClass('dropdown-open')
        },
        logout(){
            window.localStorage.removeItem('laravel-vue-spa-2');
            window.location.reload();
        },
        changeLocale(locale) {

          if (this.$auth.check()) {

            Vue.axios.post('/auth/lang', {
                lang: locale,
            }).then(({data}) => {
              this.$store.setLocale(locale)
            }).catch(function (error) {
            })
          } else {
            this.$store.setLocale(locale)
          }

        }
      },
      computed : {
        locale: function() {
          return this.$i18n.locale
        }
      },
      mounted() {

          if(this.$store.user && !this.$store.user.name ){
              window.localStorage.removeItem('laravel-vue-spa-2');
              window.location.reload();
          }


        this.$store.setProfileDropdown(this.$refs.profileDropdown)
        this.$store.setCartDropdown(this.$refs.cartDropdown)
      },
    }
</script>
